var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-alert',{staticStyle:{"margin-bottom":"20px"},attrs:{"message":_vm.$t('compute.text_1031'),"type":"warning"}}),_c('direction-list',{attrs:{"type":_vm.getParams.type,"id":_vm.getParams.id,"isRead":_vm.isRead,"listId":_vm.getParams.listId,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }